<script setup>
import { useI18n } from 'vue-i18n'
import { Link, router } from '@inertiajs/vue3'
import AppLayout from '@/Layouts/AppLayout.vue'
import PageShell from '@/Components/UI/PageShell.vue'
import SettingsTabs from '@/Components/UI/SettingsTabs.vue'
import UiButton from '@/Components/UI/UiButton.vue'
import UiTable from '@/Components/UI/UiTable.vue'
import EmptyState from '@/Components/UI/EmptyState.vue'

defineOptions({ layout: AppLayout })

const { t } = useI18n()

defineProps({
  quick_replies: { type: Array, default: () => [] },
})

const remove = (id) => {
  if (confirm(t('quickReplies.delete') + '?')) {
    router.delete(`/quick_replies/${id}`)
  }
}
</script>

<template>
  <PageShell :title="t('quickReplies.title')">
    <template #breadcrumb>
      <SettingsTabs />
    </template>
    <template #actions>
      <Link href="/quick_replies/new">
        <UiButton
          variant="primary"
          icon-left="plus"
        >
          {{ t('quickReplies.new') }}
        </UiButton>
      </Link>
    </template>

    <EmptyState
      v-if="quick_replies.length === 0"
      type="first-use"
      :title="t('quickReplies.empty')"
    />
    <UiTable
      v-else
      :columns="[
        { key: 'label', label: t('quickReplies.label') },
        { key: 'body', label: t('quickReplies.body') },
        { key: 'actions', label: '', align: 'right' },
      ]"
      :rows="quick_replies"
    >
      <template #cell-actions="{ row }">
        <div class="flex justify-end gap-3 text-xs">
          <Link
            :href="`/quick_replies/${row.id}/edit`"
            class="underline text-[color:var(--accent)]"
          >
            {{ t('quickReplies.edit') }}
          </Link>
          <button
            type="button"
            class="text-[color:var(--danger)]"
            @click="remove(row.id)"
          >
            {{ t('quickReplies.delete') }}
          </button>
        </div>
      </template>
    </UiTable>
  </PageShell>
</template>
